/**
 * The clock to measure "finished" against for the day being viewed. A past day is entirely behind
 * us, so every order on it counts as finished; a future day has none.
 */
export const dayReferenceSeconds = (currentDate: string, accountToday: string, nowSeconds: number): number => {
  if (currentDate === accountToday) {
    return nowSeconds;
  }
  // ISO dates compare chronologically as strings.
  return currentDate < accountToday ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
};
